// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"d16d807b","44":"65931b4a","83":"ac3f0aa0","106":"5d509161","237":"9191b1a4","252":"bfb5f0e1","569":"f664ff14","594":"3bb7fd92","638":"9c090c2a","881":"7e30b43e"}[chunkId] + ".chunk.js";
};